var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 5.5V7.78C21.09 8.13 21.5 8.76 21.5 9.5V15.5C21.5 16.24 21.09 16.87 20.5 17.22V19.5C20.5 20.6 19.6 21.5 18.5 21.5H4.5C3.39 21.5 2.5 20.6 2.5 19.5V5.5C2.5 4.4 3.39 3.5 4.5 3.5H18.5C19.6 3.5 20.5 4.4 20.5 5.5ZM12.5 15.5H19.5V9.5H12.5V15.5ZM4.5 19.5V5.5H18.5V7.5H12.5C11.4 7.5 10.5 8.4 10.5 9.5V15.5C10.5 16.6 11.4 17.5 12.5 17.5H18.5V19.5H4.5ZM14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5Z",
    fill: "#2771bb"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 24,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 5.5V7.78C21.09 8.13 21.5 8.76 21.5 9.5V15.5C21.5 16.24 21.09 16.87 20.5 17.22V19.5C20.5 20.6 19.6 21.5 18.5 21.5H4.5C3.39 21.5 2.5 20.6 2.5 19.5V5.5C2.5 4.4 3.39 3.5 4.5 3.5H18.5C19.6 3.5 20.5 4.4 20.5 5.5ZM12.5 15.5H19.5V9.5H12.5V15.5ZM4.5 19.5V5.5H18.5V7.5H12.5C11.4 7.5 10.5 8.4 10.5 9.5V15.5C10.5 16.6 11.4 17.5 12.5 17.5H18.5V19.5H4.5ZM14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.b508af7781c53c8760a7cd04ec7a0079.svg";
export { ForwardRef as ReactComponent };